import { TableCheckbox } from "../components/ReusableComponents/Table/tableTypes";

// extracts driverIds from each table checkbox item
export const extractDriverIds = <ItemType extends { driverId: string }>(
    selectedDrivers: TableCheckbox<ItemType>[]
) => selectedDrivers.map((selectedDriver) => selectedDriver.data.driverId);
